module.exports = {
    Get_Data : "OnlineGiftEvent.Get_Data"
    ,Update_Data : "OnlineGiftEvent.Updata_Data"
};